import * as service from '../../agent/routers/cliJsCode/service';
import { TimeoutError } from '../../errors';
import { BaseJsStepAction } from './baseJsStepAction';

export abstract class BaseCliJsStepAction extends BaseJsStepAction {
    private async executeCliCode() {
        const { step, context } = this;
        const isMobile = this.stepActionUtils.driver.isMobile;
        const hasCliAction = context.company?.activePlan?.premiumFeatures?.cliAction;

        if (!hasCliAction && !isMobile) {
            return {
                success: 'skipped',
                reason: 'CLI action is not enabled in your current plan',
            };
        }

        const { code = '', id = '' } = step;
        const { incomingParams, testResultId, retryIndex, stepResultId } = context;
        const contextData = {
            config: context.config,
            data: context.data,
        };
        const runTimeout = context.data.timeToPlayStep!;
        const data = await service.runCodeWithPackages(code, id, incomingParams, contextData, testResultId, retryIndex, stepResultId!, runTimeout);
        return this.checkCodeResponse(data);
    }

    override async performAction() {
        try {
            return await this.executeCliCode();
        } catch (err) {
            const { stepResult } = this.sessionPlayerInit.commonConstants;
            if (err instanceof TimeoutError) {
                return {
                    success: false,
                    errorType: stepResult.ACTION_TIMEOUT,
                };
            }
            return {
                success: false,
                reason: err.message,
                exception: err,
            };
        }
    }
}
